export default __webpack_public_path__ + "static/media/grabbing.a3294d26.png";